import { List } from "immutable";
import createCachedSelector from "re-reselect";

// Get all of the viewIds contained in a layout
const findAllViewIdsInLayout = viewLayout =>
  viewLayout.children
    ? viewLayout.children
      .map(c => {
        // Child is either a single view or another viewLayout
        if (c.viewId) {
          return List([c.viewId]);
        } else {
          return findAllViewIdsInLayout(c);
        }
      })
      .flatten()
    : List([viewLayout.viewId]);

const concatAllViewIdsInLayout = viewLayout => {
  return findAllViewIdsInLayout(viewLayout).join(",");
};

/**
 * This is a terribly convoluted and inefficient way of arriving at a List of
 * view ids that is a stable immutable reference
 * Thankfully, the size of items will always be small, so the cost is negligible
 * despite being so silly
 * @param {ViewLayoutRecord} viewLayout
 */
const allViewIdsInLayout = createCachedSelector(
  // input - get a string from the viewLayout
  concatAllViewIdsInLayout,
  // output - convert that string back to a List
  str => {
    return List(str.split(","));
  }
)(concatAllViewIdsInLayout);

export default {
  allViewIdsInLayout
};
